import React from 'react';
import IntroHomeView from './components/IntroHomeView';
import PPAKlarityReviewsDashboradPage from 'pages/dashboard/PPAKlarityReviewsDashboradPage';
import { Spin } from 'antd';
import s from './s.module.less';
import { getHasDoneKlarityTutorial, setHasDoneKlarityTutorial, setHasViewKlarityReviewPage } from 'utils/localstore';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';
import useCurrentUser from 'hooks/useCurrentUser';
import { canShowGroupPracticeView } from 'utils/common';
import ReviewLinkGuideModal from 'pages/dashboard/PPAKlarityReviewsDashboradPage/components/ReviewLinkGuideModal';

const Page = () => {
    const [homeInfo, loadingHomeInfo] = useProviderHomeInfo();
    const [hasConfig, setHasConfig] = React.useState(
        getHasDoneKlarityTutorial(),
    );
    const [currentUser] = useCurrentUser();
    // the walkthrough is reachable from "How it works" here too, not just from
    // the dashboard header
    const [showReviewGuide, setShowReviewGuide] = React.useState(false);

    // const fetch = async () => {
    //     try {
    //         const res = await getReputationStatus();

    //         if (res && !res.error) {
    //             setHasConfig(!!(res.data.data));
    //         } else {
    //             message.error(res.error);
    //         }
    //     } catch (e) {
    //         console.error(e);
    //     }
    // };

    // useEffect(() => {
    //     fetch();
    // }, []);

    // if (hasConfig === null) {
    //     return (
    //         <Spin spinning>
    //             <div className={s.wrap} />
    //         </Spin>
    //     );
    // }

    React.useEffect(() => {
        setHasViewKlarityReviewPage('true');
    }, []);

    // 是否显示引导页：
    // 1. 如果用户已经点击过「Learn more」或「Manage your reputation」，直接进入 dashboard（不管是否满足基础条件）
    // 2. 如果用户还没点击过，且不满足基础条件（还没完成 UniProfile 审核或还没在 Klarity 上架），显示引导页
    // 3. 如果用户还没点击过，但满足基础条件，显示引导页（等待用户点击）
    const [shouldShowIntroPage, setShouldShowIntroPage] = React.useState(true);

    // 计算 showTips 逻辑（与 IntroHomeView 保持一致）
    // 显示提示的条件：
    // 1. 未完成 UniProfile 审核
    // 2. 非 PPA Provider 且未完成 EHR 设置
    // 3. 未在 Klarity 上架
    const showTips = React.useMemo(() => {
        if (!homeInfo) {
            return true;
        }
        const uniprofileApproveCompleted = !!homeInfo.uniprofileApproveCompleted;
        const ehrSetUpCompleted = !!homeInfo.ehrSetUpCompleted;
        const ppaProvider = !!homeInfo.ppaProvider;
        const klarityListed = !!homeInfo.klarityListed;
        return (
            !uniprofileApproveCompleted ||
            (!ppaProvider && !ehrSetUpCompleted) ||
            !klarityListed
        );
    }, [homeInfo]);

    // 当 homeInfo 与 hasConfig 状态变化时，根据条件决定显示哪一页
    React.useEffect(() => {
        if (loadingHomeInfo || !homeInfo) {
            return;
        }

        // 如果用户已经点击过「Learn more」或「Manage your reputation」，直接进入 dashboard
        if (hasConfig) {
            setShouldShowIntroPage(false);
            return;
        }

        // 用户还没点击过，如果不满足基础条件，显示引导页
        if (showTips) {
            setShouldShowIntroPage(true);
            return;
        }

        // 用户还没点击过，但满足基础条件，显示引导页（等待用户点击）
        setShouldShowIntroPage(true);
    }, [loadingHomeInfo, homeInfo, hasConfig, showTips]);

    if (loadingHomeInfo) {
        return (
            <Spin>
                <div className={s.wrap} />
            </Spin>
        );
    }

    return shouldShowIntroPage ? (
        <>
            <IntroHomeView
                showTips={showTips}
                notifyHasConfig={() => {
                    // 记录用户已经点过「Learn more」或「Manage your reputation」
                    setHasDoneKlarityTutorial('true'); // 保存到 localstore，下次不用再点
                    setHasConfig(true); // 更新状态，useEffect 会自动更新 shouldShowIntroPage

                    // 点击后立即切换页面，不等待 useEffect（不管是否满足基础条件）
                    setShouldShowIntroPage(false);
                }}
                onOpenReviewGuide={() => setShowReviewGuide(true)}
            />
            <ReviewLinkGuideModal
                open={showReviewGuide}
                onClose={() => setShowReviewGuide(false)}
                showProviderPicker={canShowGroupPracticeView(currentUser)}
                uidPublic={homeInfo?.uidPublic}
                selfName={currentUser?.provider?.name}
                selfCredential={currentUser?.provider?.credential}
                selfSpecialty={currentUser?.provider?.specialties}
            />
        </>
    ) : (
        <PPAKlarityReviewsDashboradPage />
    );
};

export default Page;
